up.compiler(".up_public", function (element, data) {
  const order = ["consumerly", "privately", "otherly"];

  const default_value = element.dataset.defaultvalue;
  const selector = new Choices(element, {
    choices: data,
    shouldSortItems: true,
    sorter: function (a, b) {
      return order.indexOf(a.value) - order.indexOf(b.value);
    },
    placeholder: true,
    placeholderValue: "Choisir...",
    removeItemButton: true,
    classNames: {
      containerOuter: ["choices", "w-full"],
      containerInner: [
        "choices__inner",
        "text-xs",
        "rounded-md",
        "border",
        "border-[#B3C1BA]",
        "bg-white",
        "px-1",
      ],
      input: ["choices__input"],
    },
  });
  // force actual value
  selector.setChoiceByValue(element.value);
  // reset all
  selector.removeActiveItems();
  if (up.util.isPresent(default_value)) {
    selector.setChoiceByValue(default_value);
  }
  return () => {
    selector.destroy();
  };
});
